import { Record } from 'immutable'

export const ProTrackRecord = Record({
  id: null,
  name: null,
  label: null,
  activeUsers: 0,
  active: false,
  publicProTrackId: null,
  publicProTrackName: null,
  levels: 0,
  owner: null,
  libraryLevels: 0,
  usagePlaces: '',
})

export default class ProTrack extends ProTrackRecord {}
